import React from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../../UnidadeMedida/UnidadeMedida.css';

function UnidMedGrid(props) {
    const { arrayUnidadesMedida, clickDelete, userPermissions } = props;

    // Função de formatação de data e hora
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleString('pt-BR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    if (!arrayUnidadesMedida || arrayUnidadesMedida.length === 0) {
        return (
            <div className="text-center p-5 text-muted">
                <i className="fas fa-ruler-combined fa-3x mb-3 text-secondary"></i>
                <h5>Nenhuma unidade de medida encontrada</h5>
                <p>Não há unidades cadastradas ou que correspondam aos critérios da sua pesquisa.</p>
            </div>
        );
    }

    return (
        <div className="table-responsive">
            <table className="table table-custom table-hover align-middle mb-0">
                <thead>
                    <tr>
                        <th scope="col" className="text-center" style={{ width: '120px' }}>Ações</th>
                        <th scope="col">Descrição</th>
                        <th scope="col">Sigla</th>
                        <th scope="col">Data Cadastro</th>
                        <th scope="col">Usuário Cadastro</th>
                        <th scope="col">Data Alteração</th>
                        <th scope="col">Usuário Alteração</th>
                    </tr>
                </thead>
                <tbody>
                    {arrayUnidadesMedida.map(unidMed => (
                        <tr key={unidMed.id}>
                            <td className="text-center" data-label="Ações">
                                <div className="actions-cell">
                                    <Link
                                        to={`/app/editarunidademedida/${unidMed.id}`}
                                        className="btn-action-sm btn-edit"
                                        title="Editar"
                                        onClick={(e) => {
                                            // Validation for Edit
                                            if (userPermissions && userPermissions['editar_unidades_medida'] === false) {
                                                e.preventDefault();
                                                Swal.fire({
                                                    icon: 'error',
                                                    title: 'Acesso Negado',
                                                    text: 'Este usuário não possui permissão de edição. Por favor, contate o administrador.',
                                                    confirmButtonColor: '#2185c6'
                                                });
                                            }
                                        }}
                                    >
                                        <i className="fas fa-edit"></i>
                                    </Link>
                                    <button onClick={() => clickDelete(unidMed.id)} className="btn-action-sm btn-delete" title="Excluir">
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                            <td data-label="Descrição">{unidMed.descricao}</td>
                            <td data-label="Sigla"><span className="badge bg-light text-dark border">{unidMed.sigla}</span></td>
                            <td className="small text-muted" data-label="Data Cadastro">{formatDate(unidMed.data_cadastro)}</td>
                            <td className="small" data-label="Usuário Cadastro">{unidMed.usuario_cadastro_nome || '-'}</td>
                            <td className="small text-muted" data-label="Data Alteração">{formatDate(unidMed.data_ultima_alteracao)}</td>
                            <td className="small" data-label="Usuário Alteração">{unidMed.usuario_alteracao_nome || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default UnidMedGrid;